<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/cubes.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-7">
                <h4 class="primary-color font-600">
                  {{ $route.params.productName }} {{$t('text.categories.stock')}}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{$t('text.categories.viewStock')}}{{ $route.params.productName }} {{$t('text.categories.here')}}
                </p>
              </div>
              <div class="col-md-4 flexify">
                <!-- <select
                  class="form-control"
                  name="dealerId"
                  v-model="branchId"
                >
                  <option disabled selected value="select branch">
                    select branch
                  </option>
                  <option
                    :value="br.id"
                    v-for="(br, i) in branches"
                    :key="i"
                  >
                    {{ br.name }}
                  </option>
                </select> -->
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">{{$t('text.categories.totalStock')}}</h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/cubes-white.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ this.totalStock }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-banner mt-3">
          <div>
            <div>
              <h5 class="deep-grey bold-span">{{$t('text.categories.totalQuantitySupplied')}}</h5>
            </div>
            <div class="">
              <span
                ><span class="currency"></span
                ><span class="amount-figures"
                  >{{ convertThousand(totalQuantitySupplied) }}
                </span>
                <!-- <span class="grey-text bold-span">{{ company ? company.currency : ''}}</span> -->
              </span>
            </div>
            <div class="grey-text"></div>
          </div>
          <!-- <div class="price_change_input_wrapper w-25">
                <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :color="$store.getters.getDatePickerColor"
                    format="YYYY-MM-DDTHH:mm:ss"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.selectDate')"
                  />
              </div> -->
          <div>
            <div>
              <h5 class="deep-grey bold-span">{{$t('text.categories.totalQuantitySold')}}</h5>
            </div>
            <div>
              <span class="currency"></span
              ><span class="amount-figures">{{ totalQuantitySold }} </span>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
            >
              <e-columns>
                <e-column width="100" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="productName"
                  headerText="Product name"
                ></e-column>
                <e-column
                  width="200"
                  field="branch"
                  :headerText="$t('text.categories.station')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalQuantitySupplied"
                  :headerText="$t('text.categories.quantitySupplied')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalQuantitySold"
                  :headerText="$t('text.categories.quantitySold')"
                ></e-column>
                <e-column
                  width="150"
                  field="totalQuantityRemaining"
                  :headerText="$t('text.categories.quantityRemaining')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import AddOldUserModal from "@/components/modals/addOldUser";

import dryProductStock from "@/components/Templates/NonWetProducts/dryProductStock";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Non Wet Products :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
    AddOldUserModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      group: null,
      backgroundUrl,
      salesCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      totalStock: 0,
      branches: null,
      branchId: "select branch",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      dryProductStock: function () {
        return {
          template: dryProductStock,
        };
      },
      totalQuantitySupplied: 0,
      totalQuantitySold: 0,
    };
  },
  watch: {
    group(group) {
      if (group !== null) {
        this.getBranches();
      }
    },
    // branches() {
    //   this.getNonWetProductStock()
    // },
    // branchId() {
    //   this.getNonWetProductStock()
    // }
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    if (this.$route.query.groupId) {
      this.getBranches();
    }
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getNonWetProductStock();
  },
  methods: {
    openModal($modal) {
      this.$modal.show($modal);
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Vehicles.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/GroupBranches/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.branches = res.data;
          this.branchId = res.data[0].id;
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    refreshGrid() {},
    getNonWetProductStock() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProduct/Product/Stock/Detail/${this.$route.params.productId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.totalStock = response.data.length;
          this.totalQuantitySupplied = response.data.reduce(
            (acc, cur) => (acc += cur.totalQuantitySupplied),
            0
          );
          this.totalQuantitySold = response.data.reduce(
            (acc, cur) => (acc += cur.totalQuantitySold),
            0
          );
          this.showLoader = false;
          response.data.forEach((el, i) => {
            el.index = i + 1;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
